import { cx, styled } from "simplydo/react/styled";

import { Icon } from "../icon";
import { Slot } from "../utils/Slot";
import type { ListItemProps } from "./List.types";

const Item = styled.li`
  list-style-position: outside;
  padding: 0.8em 0;
  line-height: 1em;
  background: transparent;

  &.is-disabled {
    color: rgba(40, 40, 40, 0.3);
  }

  &.is-active {
    background: rgba(0, 0, 0, 0.05);
  }

  ${Icon}:first-child {
    margin-right: 0.5em;
  }

  &::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
`;

const ListItemComponent = (props: ListItemProps) => {
  const {
    asChild,
    children,
    className,
    style,
    onClick,
    active,
    disabled,
    ...rest
  } = props;
  return (
    <Item
      as={asChild ? Slot : undefined}
      className={cx(
        active && "is-active",
        disabled && "is-disabled",
        className,
      )}
      style={style}
      onClick={onClick}
      {...(rest as object)}
    >
      {children}
    </Item>
  );
};

export const ListItem = styled(ListItemComponent)``;
